<template>
    <div> 
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div v-if="modal" id="myModal" class="modal" @click.self="changeModal" ref="modalContent">
            <div class="modal-content" >
                <div class="modal-header">
                    <input ref="klientNazov" v-model="klient.nazov" type="text" id="klient_nazov" placeholder="Napíšte meno alebo názov klienta">
                    <svg @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                        <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div :class="klientNazovLength ? 'modal-line active' : 'modal-line'"></div>
                <div class="modal-body">
                    <div class="main">
                        <h3 class="mb-2">{{ $t('klient.text_22') }}</h3>
                        <p class="mb-4">{{ $t('klient.text_23') }}</p>
                        <div class="form-floating mb-3">
                            <input v-model="klient.spolocnost" type="text" class="form-control company_name" id="company_name" :placeholder="$t('klient.text_24')">
                            <label for="company_name">{{ $t('klient.text_24') }}</label>
                        </div>
                        <div class="d-flex">
                            <div class="form-floating mb-3 ml-0" style="width:47%;">
                                <input @keypress="ico_checker" v-model="klient.ico" type="text" class="form-control company_ico" id="company_ico" :placeholder="$t('klient.text_25')">
                                <label for="company_ico">{{ $t('klient.text_25') }}</label>
                                <span class="counter">{{ico_counter}}/8</span>
                            </div>
                            <div class="form-floating mb-3 mr-0" style="width:47%;">
                                <input @keypress="dic_checker" v-model="klient.dic" type="text" class="form-control company_dic" id="company_dic" :placeholder="$t('klient.text_26')">
                                <label for="company_dic">{{ $t('klient.text_26') }}</label>
                                <span class="counter">{{dic_counter}}/10</span>
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="klient.icdph" type="text" class="form-control company_icdph" id="company_icdph" :placeholder="$t('klient.text_27')">
                            <label for="company_icdph">{{ $t('klient.text_27') }}</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="klient.ulica" type="text" class="form-control company_adress" id="company_adress" :placeholder="$t('klient.text_28')">
                            <label for="company_adress">{{ $t('klient.text_28') }}</label>
                        </div>
                        <div class="d-flex">
                            <div class="form-floating mb-3 ml-0" style="width:47%;">
                                <input @keypress="psc_checker" v-model="klient.psc" type="text" class="form-control company_psc" id="company_psc" :placeholder="$t('klient.text_29')">
                                <label for="company_psc">{{ $t('klient.text_29') }}</label>
                            </div>
                            <div class="form-floating mb-3 mr-0" style="width:47%;">
                                <input v-model="klient.mesto" type="text" class="form-control company_town" id="company_town" :placeholder="$t('klient.text_30')">
                                <label for="company_town">{{ $t('klient.text_30') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="main">
                        <h3>{{ $t('klient.text_31') }}</h3>
                        <p class="mb-3">{{ $t('klient.text_32') }}</p>
                        <div class="form-floating mb-3">
                            <input v-model="klient.osoba" type="text" class="form-control" id="floatingInput1" :placeholder="$t('klient.text_33')">
                            <label for="floatingInput1">{{ $t('klient.text_33') }}</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="klient.email" type="email" class="form-control" id="floatingInput2" placeholder="name@example.com">
                            <label for="floatingInput2">{{ $t('klient.text_34') }}</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="klient.cislo" type="text" class="form-control" id="floatingInput3" :placeholder="$t('klient.text_35')">
                            <label for="floatingInput3">{{ $t('klient.text_35') }}</label>
                        </div>
                    </div>
                    <div class="main">
                        <h3>{{ $t('klient.text_36') }}</h3>
                        <div class="form-floating mb-3 mt-3">
                            <textarea v-model="klient.poznamky" class="form-control" :placeholder="$t('klient.text_39')" id="floatingTextarea3" style="height: 100px"></textarea>
                            <label for="floatingTextarea3">{{ $t('klient.text_39') }}</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input v-model="klient.odvetie" type="text" class="form-control" id="floatingInput4" :placeholder="$t('klient.text_38')">
                            <label for="floatingInput4">{{ $t('klient.text_38') }}</label>
                        </div>
                        <div class="combobox_zdrojkontaktu mb-3" data-app>
                            <v-combobox
                                v-model="zdroj_title"
                                :label="$t('klient.text_51')"
                                :items="zdrojTitles"
                                filled
                            >
                            </v-combobox>
                        </div>
                        <div id="floatContainer" class="float-container dateInput mb-3">
                            <label class="floatField_dateInput" for="floatField">{{ $t('klient.text_37') }}</label>
                            <date-picker 
                                v-model="klient.posledny_kontakt" 
                                format="DD.MM.YYYY" 
                                placeholder="dd.mm.rrrr" 
                                valueType="format">
                            </date-picker>
                        </div>
                    </div>
                    <pripomenutie-email
                        :pripomenut_email ="klient.pripomenut_email"
                        v-on:sendData="klient.pripomenut_email = $event"
                    />
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <div class="ulozit" @click="save">
                                <span v-show="!saved"  id="saveKlient">{{$t('klient.text_40')}}</span>
                                <div v-show="saved" class=" lds-ellipsis">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import PripomenutieEmail from "./PripomenutieEmail.vue";
    export default {
        props:['editKlient','openModal','klients','klientName','props_zdroj_kontaktu'],
        components: {
            DatePicker,
            PripomenutieEmail,
        },
        data() {
            return {
                modal: false,
                date: null,
                ico_counter: 0,
                dic_counter: 0,
                zdroj_title: "",
                klient: {
                    nazov: '',
                    posledny_kontakt: '',
                    osoba: '',
                    email: '',
                    cislo: '',
                    odvetie: '',
                    poznamky: '',
                    spolocnost: '',
                    ico: '',
                    dic: '',
                    icdph: '',
                    ulica: '',
                    psc: '',
                    mesto: '',
                    zdroj_kontaktu_id: null,
                    pripomenut_email: ''
                },
                
                isEdit: false,
                error:false,
                saved: false
               
            }
        },
        methods: {
            changeModal() {
                this.modal = !this.modal
                if(this.modal){
                    if(this.editKlient?.id){
                        this.klient = this.editKlient
                        this.isEdit = true
                    }
                    if(this.klientName != null && this.klientName != ""){
                        this.klient.nazov = this.klientName
                    }
                    document.documentElement.style.overflow = 'hidden';
                    setTimeout(() => {
                        this.$refs.klientNazov.focus();
                    }, 500);
                }else{
                    document.documentElement.style.overflow = 'auto';
                    this.$emit('closeModal', false);
                    this.resetKlient()
                    this.isEdit = false
                }
            },
            notBeforeToday(date) {
                return date < new Date(new Date().setHours(0, 0, 0, 0));
            },
            customFormatter(date) {
                return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            },
            
            psc_checker(event){
                const inputVal = event.target.value;
                const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                if (cleanedVal.length > 4) {
                    this.klient.psc = cleanedVal.substr(0, 4); // Limit length to 8 characters
                } else {
                    this.klient.psc = cleanedVal;
                }
            },
            ico_checker(event){
                const inputVal = event.target.value;
                const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                if (cleanedVal.length > 7) {
                    this.klient.ico= cleanedVal.substr(0, 7); // Limit length to 8 characters
                } else {
                    this.klient.ico= cleanedVal;
                }
            },
            dic_checker(event){
                const inputVal = event.target.value;
                const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
                if (cleanedVal.length > 9) {
                    this.klient.dic = cleanedVal.substr(0, 9); // Limit length to 8 characters
                } else {
                    this.klient.dic = cleanedVal;
                }
            },

            resetKlient(){
                this.modal= false,
                this.ico_counter= 0,
                this.dic_counter= 0,
                this.klient= {
                    nazov: '',
                    posledny_kontakt: '',
                    osoba: '',
                    email: '',
                    cislo: '',
                    odvetie: '',
                    poznamky: '',
                    spolocnost: '',
                    ico: '',
                    dic: '',
                    icdph: '',
                    ulica: '',
                    psc: '',
                    mesto: '',
                    zdroj_kontaktu_id: null,
                    pripomenut_email: '',
                },
                this.zdroj_title = ""
                this.isEdit= false,
                this.error=false,
                this.saved= false
            },
            save() {
                if (this.klient.nazov.trim() === "") {
                    this.$nextTick(() => {
                        this.$refs.modalContent.scrollTop = 0;
                        this.$refs.klientNazov.focus();
                    });
                    this.$toast.error(this.$t('klient.text_42'), { timeout: 2038 });
                } else {
                    const exists = this.klients.some(klient => klient.nazov.trim() === this.klient.nazov.trim());
                    const exists_id = this.klients.some(klient => klient.id === this.klient.id);
                    if (!exists || (exists && this.isEdit && exists_id)) {
                        this.saved = true;
                        axios.post(`/api/klients`, {
                            klient: this.klient,
                            isEdit: this.isEdit
                        })
                        .then(response => {                            
                            this.$toast.success((this.isEdit ? this.$t('klient.text_44') : this.$t('klient.text_43')), { timeout: 2038 });
                            if(!this.isEdit)
                                this.$emit('addClient', response.data);
                            this.$emit('reload');
                            this.changeModal();
                        })
                        .catch(error => {});
                    } else {
                        this.$nextTick(() => {
                            this.$refs.modalContent.scrollTop = 0;
                            this.$refs.klientNazov.focus();
                        });
                        this.$toast.error(this.$t('klient.text_45'), { timeout: 2038 });
                    }
                }
            },
            getIdByName: function () {
                const zdroj = this.props_zdroj_kontaktu.find(
                    (zdroj) => zdroj.title === this.zdroj_title
                );
                return zdroj ? zdroj.id : null;
            },

        },
        watch: {
            'klient.zdroj_kontaktu_id': function(){
                if(this.klient.zdroj_kontaktu_id != null){
                    const zdroj = this.props_zdroj_kontaktu.find(
                        (zdroj) => zdroj.id === this.klient.zdroj_kontaktu_id
                    );
                    this.zdroj_title = zdroj ? zdroj.title : null;
                }
            },
            zdroj_title: function () {
                this.klient.zdroj_kontaktu_id = this.getIdByName();
            },
            'openModal': function(){
                if(this.openModal)
                    this.changeModal()
            },
            'date': function(){
                this.klient.posledny_kontakt = this.date
            },
            'klient.ico':  function(){
                this.ico_counter = this.klient.ico ? (this.klient.ico.toString()).length : 0
            },
            'klient.dic':  function(){
                this.dic_counter = this.klient.dic ? (this.klient.dic.toString()).length : 0
            },
            'klient.nazov':function(){
                this.error = false
                if(this.klient.nazov == ''){
                    this.error = true
                }
            }
        },
        computed: {
            zdrojTitles: function () {
                return this.props_zdroj_kontaktu.map((zdroj) => zdroj.title);
            },
            klientNazovLength() {
                if(this.klient.nazov.length > 0)
                    return true
                return false
            }
        },
    }
</script>
<style lang="scss">
.combobox_zdrojkontaktu {
    .v-menu {
        .v-menu__content {
            left: 0 !important;
        }
    }
    .v-input {
        height: 56px;
        width: 100%;
    }
    .v-autocomplete__content.v-menu__content{
        position: absolute !important;
    }
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff;
    }
    input {
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 16px !important;
        color: #212529 !important;
    }
    .v-input__slot,
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff !important;
        border: 1px solid #ced4da !important;
        border-radius: 0.25rem !important;
        input {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212529 !important;
        }
    }

    .v-text-field > .v-input__control > .v-input__slot {
        &:after {
            content: none !important;
        }
        &:before {
            content: none !important;
        }
    }
    .v-label.v-label--active.theme--light {
        left: -11px !important;
        top: 14px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
    .v-label.theme--light {
        top: 22px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
}
.floatField_dateInput{
        color: #9598a7;
        font-family: Roboto;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: .1em;
        line-height: 13px;
        margin-top: 0;
        margin-bottom: 0;
        text-transform: uppercase;
        padding: 10px 0 0 17px;
    }
#klient_nazov::-webkit-contacts-auto-fill-button {
  visibility: hidden;
  display: none !important;
  pointer-events: none;
  position: absolute;
  right: 0;
}
.Vue-Toastification__container.top-right{
    z-index: 100000 !important;
}
.mx-datepicker-popup{
    z-index: 100000 !important;
}
</style>
<style lang="scss" scoped>

.lds-ellipsis {
display: inline-block;
position: relative;
width: 80px;
height: 80px;
}
.lds-ellipsis div {
position: absolute;
top: 33px;
width: 13px;
height: 13px;
border-radius: 50%;
background: #fff;
animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
left: 8px;
animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
left: 8px;
animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
left: 32px;
animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
left: 56px;
animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
0% {
    transform: scale(0);
}
100% {
    transform: scale(1);
}
}
@keyframes lds-ellipsis3 {
0% {
    transform: scale(1);
}
100% {
    transform: scale(0);
}
}
@keyframes lds-ellipsis2 {
0% {
    transform: translate(0, 0);
}
100% {
    transform: translate(24px, 0);
}
}  
.ulozit{
    width: 560px;
    height: 55px;
    margin: 0 auto;
    background: #2ED8B6;
    border: none;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 182.5%;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    &:hover{
        background: #26b195;
    }
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
.form-floating>label{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.05em;
    margin-top: 5px;
    text-transform: uppercase;
    color: #9598A7;
}
.form-group{
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
*{
    font-family: 'Roboto', sans-serif;
}
.form-floating{
    width: 100%;
    margin: 0 auto;
    position: relative;
    .counter{
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 10px;
        font-weight: 300;
        color: #9598A7;
    }
}
.modal {
    display: block;
    position: fixed; 
    z-index: 10000; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);
    .modal-content {
        margin: 100px auto 100px auto;
        background: #F7F7F7;
        width: 674px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
        padding-bottom: 50px;
        @media (max-width: 600px) {
            width: 95% !important;
            margin: 50px auto 50px auto;
        }
        .modal-line{
            width: 673px;
            height: 1px;
            background: rgba(215, 60, 120, 0.40);
            transition: opacity .5s;
            &.active{
                background: #D73C78;
            }
            @media (max-width: 600px) {
                width: 100% !important;
            }
        }
        .modal-header{
            margin: 35px auto;
            width: 578px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;
            @media (max-width: 600px) {
                width: 100% !important;
            }
            input{
                width: 427px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541; // Change text color to #212541
                &::placeholder {
                    color: #A3A3A3; // Change placeholder color to #A3A3A3
                }
                @media (max-width: 600px) {
                    width: 100% !important;
                }
            }
            svg{
                transition: transform .5s;
                &:hover{
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }
        .modal-body{
            padding: 0;
            .main{
                width: 578px;
                margin: 0 auto;
                border-radius: 4px;
                background: #FFF;
                box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
                padding: 20px;
                margin-top: 22px;
                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
                h3{
                    width: auto;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 18px;
                    line-height: 21px;
                    color: #212541;
                }
                p{
                    font-family: 'Roboto';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 16px;
                    color: #9598A7;
                }
                .ulozit{
                    width: 474px;
                    @media only screen and (max-width: 600px) {
                        width: 90%;
                    }
                    height: 55px;
                    margin: 37px auto 75px auto;
                    background: #2ED8B6;
                    border-radius: 4px;
                    font-family: 'Roboto', sans-serif;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 19px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    justify-content: center;
                    color: #FFFFFF;
                    cursor: pointer;
                    transition: .5s all;
                    &:hover{
                        background: #23caa9;
                    }
                }
            }
        }
    }
}
</style>